import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import { useRef, useState } from 'preact/hooks';

import HomeHighlightsList from './HomeHighlightsList';
import HomeVideoSection, { MiniPlayerContentMode } from './HomeVideoSection';

const HomeContent = () => {
  const [highlightIndex, setHighlightIndex] = useState(0);
  const [miniPlayerContentMode, setMiniPlayerContentMode] = useState<MiniPlayerContentMode>('highlight');
  const ref = useRef<HTMLDivElement>(null);
  const { data } = useQuery<{ total: number; list: any[] }>({
    queryKey: ['/videos?type=curated&sortOrder=desc&pageSize=12'],
  });

  const onNextHighlight = () => {
    if (!data) return;
    setHighlightIndex((highlightIndex + 1) % data.list.length);
  };

  const onHighlightClick = (highlight: any) => {
    if (!data) return;
    setHighlightIndex(data.list.indexOf(highlight));
    setMiniPlayerContentMode('live-stream');
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const onSwitchContentMode = () => {
    setMiniPlayerContentMode((prev) => (prev === 'highlight' ? 'live-stream' : 'highlight'));
  };

  return (
    <div ref={ref}>
      <HomeVideoSection
        miniPlayerContentMode={miniPlayerContentMode}
        highlight={data?.list[highlightIndex]}
        onNextHighlight={onNextHighlight}
        onSwitchContentMode={onSwitchContentMode}
      />
      <div className="px-4 py-3">
        <div className="flex justify-between">
          <h4 className="preflight preflight-h4 font-bold">Check out zoolife’s highlights</h4>
          <a href="/highlights" className="preflight preflight-a flex items-center gap-1 text-xs font-medium text-grey-3">
            <span>See all</span>
            <FontAwesomeIcon icon={faChevronRight} />
          </a>
        </div>
        <p className="preflight preflight-p mb-3 mt-2 text-xs font-medium text-grey-6">Click a video to play.</p>
        <HomeHighlightsList highlights={data?.list} onHighlightClick={onHighlightClick} />
      </div>
    </div>
  );
};

export default HomeContent;
